export const costs = [
  'Sleepless nights searching for ways to translate complex industrial maintenance concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how industrial maintenance connects to their futures, careers, or real-world equipment operation.",
  "Awkward silences when a student asks about bearing wear patterns or electrical fault diagnosis and you don't have a clear answer.",
  'Weekends lost building lesson plans, maintenance projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach mechanical systems, electrical maintenance, reliability analysis, troubleshooting, or safety without adequate resources.',
];
